import { EQuizStatus } from '@constants';
import { Select } from 'antd';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useActivityQuizzesForSelector } from '@/store';
import { handleInputValue } from '@/utils';

type Props = {
  value?: string;
  courseId?: string;
  placeholder?: string;
  allowClear?: boolean;
  onChange?: (value: string) => void;
};

export const QuizActivitySelector: React.FC<Props> = ({
  courseId,
  allowClear,
  placeholder,
  value,
  onChange
}) => {
  const { quizzes = [] } = useActivityQuizzesForSelector(courseId);
  const { t } = useTranslation('StudentQuizTranslations');

  const options = useMemo(() => {
    return quizzes.map(quiz => ({
      label: `(${t(quiz.mode)}) - ${quiz.title}`,
      value: quiz._id,
      disabled: quiz.status !== EQuizStatus.PUBLISHED
    }));
  }, [quizzes]);

  return (
    <Select
      showSearch
      options={options}
      onChange={onChange}
      allowClear={allowClear}
      placeholder={placeholder}
      filterOption={(input, option) =>
        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
      }
      value={handleInputValue(value)}>
      {options.map(option => (
        <Select.Option key={option.value} value={option.value} disabled={option.disabled}>
          {option.label}
        </Select.Option>
      ))}
    </Select>
  );
};
